import i18n from 'modules/core/lib/i18n'

import { TaskDefinition } from 'modules/inbox_tasks/lib/abstraction'

export const EmployeeUpdateTaskDefinition: TaskDefinition<'BookkeepersManagementIncidence'> = {
  taskableTypename: 'BookkeepersManagementIncidence',
  getUrl: ({ resourceId, navigation }) => {
    if (!resourceId) {
      return navigation.compensations.employeeUpdates.fullPath()
    }

    return navigation.compensations.employeeUpdates.id.fullPath({ id: resourceId })
  },
  getTitle: () => {
    return i18n.t('tasks.inbox.titles.manage_employee_updates_grouped_update')
  },
}
